import { render, staticRenderFns } from "./SoftwareItem.vue?vue&type=template&id=66c2d973&scoped=true&"
import script from "./SoftwareItem.vue?vue&type=script&lang=js&"
export * from "./SoftwareItem.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareItem.vue?vue&type=style&index=0&id=66c2d973&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c2d973",
  null
  
)

export default component.exports